import { LogicContext } from '../types';

import { fetchJackpots as fetchJackpotsFromBFF } from '../../../model/jackpots';
import { JackpotsQueryType } from '../../../types/jackpotTypes';
import config from '../../../config';

export const fetchJackpots = async (context: LogicContext) => {
  const { controllersData } = context;

  if (!controllersData.categories) {
    return {
      jackpots: {},
    };
  }

  const { components } = controllersData.categories;
  const jackpotIds = new Set<JackpotsQueryType>();

  components
    .map(([id, entry]) => entry.properties.jackpot_widget?.provider)
    .filter(Boolean)
    .flat()
    .forEach(id => id && jackpotIds.add(id as JackpotsQueryType));

  if (jackpotIds.size === 0) {
    return {
      jackpots: {},
    };
  }

  const jackpots = await fetchJackpotsFromBFF(
    Array.from(jackpotIds),
    context.user?.currency || config.default_currency
  );

  return {
    jackpots,
  };
};
